<div
  *ngIf="mapOptions"
  [style.height]="mapHeight()"
  class="map-container"
  leaflet
  leafletPing
  [leafletPingOptions]="leafletPingOptions"
  (leafletPingObserver)="setLeafletPingObserver($event)"
  [leafletOptions]="mapOptions"
  (leafletMapReady)="onMapReady($event)"
></div>

<bi-spinner *ngIf="loading()" [centerInParent]="true" [hasBackground]="true" spinnerSize="large" [fixedPosition]="false" />
